import io from 'socket.io-client';
// import io from 'socket.io-client/dist/socket.io.slim.js';
import jstz from 'jstz';
import numeral from "numeral";
import 'lazysizes';

const prefersDark = require('./prefers-dark');

window.axios = require('axios');
window.axios.defaults.baseURL = process.env.MIX_APP_URL;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.io = io;
window.jstz = jstz;
window.numeral = numeral;

if (process.env.MIX_BROADCAST_DRIVER === 'pusher') {
    require('./plugins/pusher');
} else {
    require('./plugins/echo');
}

require('./plugins/day');
